<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4QSpcP/tc-custom/9781631683640.jpg?1702596437155" alt="This image is the cover for the book Jason and the Argonauts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jason and the Argonauts
      </h1>
      <p class="bookDescription body article font2">
        <b>Renowned mythologist Bernard Evslin’s retelling of the perilous adventure of Jason and the Argonauts </b><br/><br/> “This story begins very soon after the world began, when great raw things called monsters roamed the unfinished places eating whatever they could catch.” So says Ekion, son of the god Hermes, as he relates the tale of the treacherous crusade of Jason and the Argonauts. When Jason, a prince with the gift of healing, is assigned a quest to obtain the golden fleece of the winged ram—which, once obtained, will set Jason upon his rightful throne as king—a fantastic adventure begins. In the vein of classic storytelling, mythologist Bernard Evslin offers his own masterful recasting of the famous tale of Jason, Medea, and the Argonauts, and follows the hero’s journey to its startling and tragic conclusion.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernard Evslin
      </h2>
      
      <p class="authorDescription body article">Bernard Evslin (1922&ndash;1993) was a bestselling and award-winning author known for his works on Greek and other cultural mythologies. The <i>New York Times</i> called him &ldquo;one of the most widely published authors of classical mythology in the world.&rdquo; He was born in New Rochelle, New York, and attended Rutgers University. After several years working as a playwright, screenwriter, and documentary producer, he began publishing novels and short stories in the late 1960s. During his long career, Evslin published more than seventy books&mdash;over thirty of which were for young adults. His bestseller <i>Heroes, Gods and Monsters of the Greek Myths</i> has been translated into ten different languages and has sold more than ten million copies worldwide. He won the National Education Association Award in 1961, and in 1986 his book <i>Hercules</i> received the Washington Irving Children&rsquo;s Book Choice Award. Evslin died in Kauai, Hawaii, at the age of seventy-seven.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50658411